import useFeaturePermissions from './useFeaturePermissions';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity number ranges
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useNumberRangesPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(organizationId, Permissions.NumberRangesChange, Permissions.NumberRangesRead);
  return { writePermission, readPermission };
};
